import { PureComponent } from 'react';

type ChildrenArgs = { current: number | string; switchTo: (switchToIndex: number | string) => void };

type Props = {
  current: number | string;
  /**
   * @param {Object} renderProps
   * @param {number} renderProps.current
   * @param {function} renderProps.switchTo
   * @return {React.Node}
   */
  children: (args: ChildrenArgs) => JSX.Element;
};

type State = {
  current: number | string;
};

/**
 * Use in cases you need interactive switching between many values.
 * Gadget calls children function with current values.
 * Rendering of the content is completely independent.
 *
 * @tags gadget, switch, toggle
 */
export class Switchable extends PureComponent<Props, State> {
  public static displayName = 'Switchable';

  public static defaultProps = {
    current: 0
  };

  public state = {
    current: this.props.current
  };

  /**
   * @param {number} current
   */
  private switchTo = (current: number | string) => {
    this.setState({ current });
  };

  public render() {
    const { props, state } = this;

    return props.children({
      current: state.current,
      switchTo: this.switchTo
    });
  }
}
